import React from 'react'
import { parseaFechaHora } from '../../utils';
import { useTranslate } from '../../contexts/languageContext';

export default function Header(props) {
  const data = props.data.data;
  const ambito = props.nomenclator.ambitos[data.elec].find(
    x => x.c === data.amb
  );
  const [hora, fecha] = parseaFechaHora(data.mdhm).split(' - ');
  const esBoletin = data.tope === '1' || data.amb.length >= 9;
  const t = useTranslate();
  return (
      <div className="header">
      <div className="nombreElec">{props.nomenclator.nomAmbitos[data.elec].n}</div>
      <div className="ambitoyDatos">{data.amb.length === 19 ?  `MESA ${Number(data.amb.slice(13, 19))}`:ambito.n}
        <br/>
        <div className="datosdeLas">{`${esBoletin ? t('boletin') : t('avance')} ${data.amb.length >= 9 ? "9999" : data.numact} (${hora} ${fecha})`}</div>
      </div>
    </div>
    );
}

export function HeaderEstadisticas(props) {
  const eleccionID = props.elec;
  return (
      <div className="header">
      <div className="nombreElec">{props.nomenclator.nomAmbitos[eleccionID].n}</div>
      <div className="ambitoyDatos">COLOMBIA
      </div>
    </div>
    );
}